module.exports = __webpack_public_path__ + "img/倒數開始_0.20c10313.png";